import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Switch to new UI to use this feature.", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewAdminNotification = _resolveComponent("NewAdminNotification")!

  return (_ctx.isNewAdminEnabled)
    ? (_openBlock(), _createBlock(_component_NewAdminNotification, {
        key: 0,
        notificationList: _ctx.notificationList,
        notificationMethods: _ctx.notificationMethods,
        searchNotifications: _ctx.searchNotifications,
        loading: _ctx.loading,
        socketMethods: _ctx.socketMethods,
        totalCount: _ctx.totalCount,
        limit: _ctx.limit,
        changePage: _ctx.handlePageChange
      }, null, 8, ["notificationList", "notificationMethods", "searchNotifications", "loading", "socketMethods", "totalCount", "limit", "changePage"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}